import queries from '@apis/queries';
import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import { useQuery } from '@tanstack/react-query';
import { useRef } from 'react';

import useCompleteAnimation from './hooks/useCompleteAnimation';
import styles from './styles.module.scss';

interface Props {
    userPrepaidCardId: string;
}
function Complete({ userPrepaidCardId }:Props) {
  const ref = useRef<HTMLDivElement>(null);
  const cardRef = useRef<HTMLImageElement>(null);
  const { data } = useQuery(queries.userPrepaidCard.detail(userPrepaidCardId));
  useCompleteAnimation({
    ref, cardRef, imageUrl: data?.imageUrl, userPrepaidCardId,
  });
  return (
        <div className={`${styles.container} ${styles.none} ${styles.hide}`}
             ref={ref}>
            <div className={styles.cardWrapper}>
                <Image src={data?.imageUrl}
                       width={300}
                       height={200}
                       ref={cardRef}
                       className={styles.card}
                       alt='카드 이미지' />
            </div>
            <Column align='center' spacing={18}>
                <Text color={colors.gray7} size='3xl' fontWeight='bold' >
                    카드 구매가 완료되었습니다!
                </Text>
                <Text color={colors.gray7}>
                    구매한 카드는 바로 사용 가능합니다.
                </Text>
            </Column>
        </div>
  );
}

export default Complete;
